import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PublicGoogleMapLoader from "../../utils/PublicGoogleMapsLoader";
import MapViewPublic from "./MapViewPublic";
import { makeGetRequestToUrl } from "../commonFunc";
import config from "../../config/config";

async function decryptKey(hex, password, salt) {
  try {
    const buf = new Uint8Array(hex.match(/.{1,2}/g).map(b => parseInt(b, 16)));
    
    // Slicing logic for 12-byte IV and 16-byte Tag
    const iv = buf.slice(0, 12);
    const tag = buf.slice(12, 28);
    const data = buf.slice(28);

    // 1. Derive Key
    const baseKey = await crypto.subtle.importKey(
      "raw", new TextEncoder().encode(password), "PBKDF2", false, ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
      { name: "PBKDF2", salt: new TextEncoder().encode(salt), iterations: 100000, hash: "SHA-256" },
      baseKey,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"]
    );

    // 2. Decrypt (Web Crypto expects Data followed by Tag)
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv, tagLength: 128 },
      key,
      new Uint8Array([...data, ...tag])
    );

    return new TextDecoder().decode(decrypted);
  } catch (e) {
    console.error("Decryption failed. Check if IV/Tag lengths match backend.", e);
    throw e;
  }
}

const PASSWORD = "G0ulue7M9YbM<0j0";
const SALT = "4Nv3E.wvR|h$!#dZ";

const PublicTrackingPage = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const [googleKey, setGoogleKey] = useState(null);
  const [hereKey, setHereKey] = useState(null);
  const [rideData, setRideData] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const favicon = document.getElementById("dynamic-favicon");
    if (!favicon) return;
    const isLiveTracking = location.pathname.includes("livetracking");
    favicon.href =
      isLiveTracking && data?.favicon ? data.favicon : "/trackinglocation.png";
  }, [location.pathname, data]);

  useEffect(() => {
    const isLiveTracking = location.pathname.includes("livetracking");
    if (isLiveTracking) {
      document.title = data?.brand_name
        ? `Live Tracking - ${data.brand_name}`
        : "Live Tracking";
    } else {
      document.title = "Admin Panel";
    }
  }, [location.pathname, data]);

  useEffect(() => {
    if (!token) return;

    const fetchData = async () => {
      const res = await makeGetRequestToUrl(
        `${config.serverUrl}/driver/fetch_tracking_link`,
        { token }
      );
      if (res.flag !== 200 || !res.data?.length) return;

      const rideRecord = res.data[0];
      setData(res);
      setRideData(rideRecord);
      try {
        if (res?.google_key) {
          const buf = new Uint8Array(
  res.google_key.match(/.{1,2}/g).map(x => parseInt(x, 16))
);

          const decryptedGoogle = await decryptKey(
            res?.google_key.toString(),
            PASSWORD,
            SALT
          );
          setGoogleKey(decryptedGoogle);
        }

        if (rideRecord.is_safest_route === 1 && res.here_maps_api_key) {
          const decryptedHere = await decryptKey(
            res.here_maps_api_key.toString(),
            PASSWORD,
            SALT
          );
          setHereKey(decryptedHere);
        }
      } catch (e) {
        console.error("Key decryption failed", e);
      }
    };

    fetchData();
  }, [token]);
  console.log(rideData,"=ridedata")
  console.log(googleKey,"google key")

  if (!rideData || !googleKey) {
    return <div>Preparing secure map…</div>;
  }

  if (rideData.is_safest_route === 1 && !hereKey) {
    return <div>Preparing secure map for safest Route…</div>;
  }

  return (
    <PublicGoogleMapLoader googleKey={googleKey}>
      {({ isLoaded }) => (
        <MapViewPublic
          rideDetails={rideData}
          isLoaded={isLoaded}
          data={data}
          hereApiKey={hereKey}
        />
      )}
    </PublicGoogleMapLoader>
  );
};

export default PublicTrackingPage;